import { render } from "./AddFamilyMemberModal.vue?vue&type=template&id=2f0bcd9c"
import script from "./AddFamilyMemberModal.vue?vue&type=script&lang=js"
export * from "./AddFamilyMemberModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__